module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"counter":"Counter","gsmSignal":"GSM signal","rssi":"RSSI","sf":"SF","snr":"SNR"},"de":{"counter":"Counter","gsmSignal":"GSM-Signal","rssi":"RSSI","sf":"SF","snr":"SNR"},"fr":{"counter":"Counter","gsmSignal":"Signal GSM","rssi":"RSSI","sf":"SF","snr":"SNR"},"it":{"counter":"Counter","gsmSignal":"Segnale GSM","rssi":"RSSI","sf":"SF","snr":"SNR"}}')
  delete Component.options._Ctor
}
